import { useCallback } from 'react'
import { useShoppingCartContext } from '../../../../../providers/ShoppingCartProvider'
import shoppingCartV2API from '../../../../../api'
import nrLogger from '../../../../../../../helpers/nrLogger'

const useUpdateWarrranty = params => {
  const {
    data,
  } = params

  const {
    getCartId,
    getIdentifier,
    setCart,
    shouldShowLoader,
  } = useShoppingCartContext()

  return useCallback(
    async isChecked => {
      shouldShowLoader(true)

      try {
        const items = [
          {
            product: {
              productId: data.product.productId,
            },
          },
        ]

        let res = {}
        const identifier = getIdentifier()
        const cartId = getCartId()
        if (isChecked === false) {
          res = await shoppingCartV2API.warranties.remove(identifier, cartId, items)
        } else {
          res = await shoppingCartV2API.warranties.update(identifier, cartId, items)
        }

        setCart(res)
      } catch (error) {
        nrLogger.error('ShoppingCartV2.useUpdateWarrranty.error', error)
      }

      shouldShowLoader(false)
    },
    [data, shouldShowLoader, getIdentifier, getCartId, setCart],
  )
}

export default useUpdateWarrranty
